import React, { useEffect, useState } from "react";
import Title from "antd/es/typography/Title";
import { Card, Table, Modal, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import { Row, Col } from "react-bootstrap";
import axios from "axios";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { baseURL } from "../store/api/axios";
import { decryptdata } from "../utils/encryptDecrypt";

const UtmMapping = () => {
  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("")
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);

  const [value, setValue] = React.useState('one'); // Track the selected tab
          
  const handleChange = (event, newValue) => {
    setValue(newValue); // Update the selected tab
  };
      

  const columns = [
    {
      title: "Subscriber ID",
      dataIndex: "userId",
      key: "userId",
    },
    {
      title: "Business Name",
      dataIndex: "userDetails",
      key: "businessName",
      render: (userDetails) => userDetails?.name || "-",
    },
    {
      title: "Company Name",
      dataIndex: "userDetails",
      key: "companyName",
      render: (userDetails) => userDetails?.companyName || "-",
    },
    {
      title: "Business Email",
      dataIndex: "userDetails",
      key: "businessEmail",
      render: (userDetails) => userDetails?.email || "-",
    },
    {
      title: "Business Number",
      dataIndex: "userDetails",
      key: "phoneNumber",
      render: (userDetails) => userDetails?.mobileNo || "-",
    },
    {
      title: "UTM Lead ID",
      dataIndex: "leadId",
      key: "leadId",
    },
  ];

  const handleExpand = (expanded, record) => {
    setExpandedRowKeys((prevKeys) => {
      if (expanded) {
        return [record._id]; // Add the key if expanding
      } else {
        return prevKeys.filter((key) => key !== record._id); // Remove if collapsing
      }
    });
  };
  //Get Overall Leads List
  const getLeads = async () => {
    try {
      const accessToken = localStorage.getItem("accessToken");
      const res = await axios.get(
        `${baseURL}lead/distributedutmleadslist`,
        { headers: { Authorization: `${accessToken}` } }
      );

      const decrypt = decryptdata(res.data);
      const data = decrypt?.data?.data?.utmdistributedleads?.map((item, index) => ({
        ...item,
        key: item._id || index.toString(), // Ensure each row has a unique key
      }));

      setData(data);
    } catch (error) {
      console.error("Error fetching leads:", error);
    }
  };

  useEffect(() => {
    getLeads();
  }, []);


  const filteredData = data.filter((item) =>
    item.leadId?.toString().toLowerCase().includes(searchTerm.toLowerCase())
  );




  return (
    <div>
      <Title level={3}>Movers UTM Mapped Leads</Title>
        <Tabs value={value} onChange={handleChange} textColor="primary" indicatorColor="primary" aria-label="primary tabs example">
                <Tab value="one" label="Movers" />
                <Tab value="two" label="Health Care" />
                <Tab value="three" label="Financial Service" />
                <Tab value="four" label="Manufacturing" />
                <Tab value="five" label="Real Estate" />
                <Tab value="six" label="E-Commerce" />
            </Tabs>
            {value == 'one' && (
                   <>
           <Row>
        <Col md={6}>
        {/* <Title level={4}>Mapped Leads</Title> */}

        </Col>
        <Col md={6} style={{textAlign:'end'}} className="my-3">
        <Link to="/admin/utm-mapping-form">
            <Button variant="contained">Map Business & UTM</Button>{" "}
          </Link></Col>
      </Row>

      <Card
        extra={
         <>
              <Input
                placeholder="Search UTM ID..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                prefix={<SearchOutlined style={{ color: "#888" }} />}
                style={{ borderRadius: "5px", padding: "8px 12px" }} />
         </>
        }
        style={{ width: "100%" }}>
        <Table
          dataSource={filteredData}
          columns={columns}
          expandable={{
            expandedRowRender: (item) => (
              <>
                <Row>
                  <Col md={4}>
                    <div style={{ display: "grid" }}>
                      <p style={{ color: "#595959" }}>Lead Details</p>
                      <span className="mb-2">
                        UTM lead ID : {item?.leadId || "-"}
                      </span>
                      <span className="mb-2">
                        Registered Date:{" "}
                        {new Date(item.createdAt).toISOString().slice(0, 10) ||
                          "-"}
                      </span>
                      <span className="mb-2 d-flex">
                        Move on Date: {item?.leadData?.movingDate || "-"}
                      </span>
                    </div>
                  </Col>
                  <Col md={4}>
                    <div style={{ display: "grid" }}>
                      <span className="mb-2">
                        Name : {item?.leadData?.name || "-"}
                      </span>
                      <span className="mb-2">
                        Phone Number : {item?.leadData?.phone || "-"}
                      </span>
                      <span className="mb-2">
                        Email ID : {item?.leadData?.email || "-"}
                      </span>
                      <span className="mb-2">
                        Property Size : {item?.leadData?.propertySize || "-"}
                      </span>
                    </div>
                  </Col>
                  <Col md={4}>
                    <div style={{ display: "grid" }}>
                      <span className="mb-2">
                        Moving from: {item?.leadData?.movingFrom || "-"}
                      </span>
                      <span className="mb-2">
                        Moving to : {item?.leadData?.movingTo || "-"}
                      </span>
                      <span className="mb-2">
                        Available time to call:{" "}
                        {item?.leadData?.timeToCall || "-"}
                      </span>
                      <span className="mb-2">
                        Property Type: {item?.leadData?.propertyType || "-"}
                      </span>
                    </div>
                  </Col>
                </Row>
              </>
            ),
            rowExpandable: (record) => record.name !== "Not Expandable",
            expandedRowKeys: expandedRowKeys,
            onExpand: handleExpand,
          }}
        />
      </Card>
                   </>
                      )}

        {value === 'two' && (
        <Box sx={{p:5}}>
            <h3 style={{textAlign:'center', marginTop:'20px'}}>The Health Care UTM lead table is set to start</h3>
        </Box>
      )}
      {value === 'three' && (
        <Box sx={{p:5}}>
          <h3 style={{textAlign:'center', marginTop:'20px'}}>The Financial Service UTM lead table is set to start</h3>
      </Box>
      )}
      {value === 'four' && (
        <Box sx={{p:5}}>
           <h3 style={{textAlign:'center', marginTop:'20px'}}>The Manufacturing UTM lead table is set to start</h3>
       </Box>
      )}
      {value === 'five' && (
        <Box sx={{p:5}}>
           <h3 style={{textAlign:'center', marginTop:'20px'}}>The Real Estate UTM lead table is set to start</h3>
       </Box>
      )}
      {value === 'six' && (
        <Box sx={{p:5}}>
           <h3 style={{textAlign:'center', marginTop:'20px'}}>The E-Commerce UTM lead table is set to start</h3>
       </Box>
      )}             
    </div>
  );
};

export default UtmMapping;



// import React from 'react'
// import Title from "antd/es/typography/Title";
// import { Card, Table, Modal } from 'antd';
// import {Link} from 'react-router-dom';
// import {Button} from '@mui/material'
// import {Row,Col} from 'react-bootstrap';


// const UtmMapping = () => {
//     const dataSource = [
//         {
//           key: '1',
//           businessName:'Sam paul',
//           comapnayName: 'Survey Sparrow',
//           businessEmail: 'surveyparrow@gmail.com',
//           phoneNumber:982739484,
//           utmleadID: 12,
//         },
//         {
//           key: '2',
//           businessName:'Refai Ahammed',
//           comapnayName: 'Eucto',
//           businessEmail: 'hello@eucto.com',
//           phoneNumber:7636289172,
//           utmleadID: 13,
//         },
//       ];
      
//       const columns = [
//         {
//           title: 'Business Name',
//           dataIndex: 'businessName',
//           key: 'businessName',
//         },
//         {
//           title: 'Company Name',
//           dataIndex: 'comapnayName',
//           key: 'comapnayName',
//         },
//         {
//           title: 'Bussiness Email',
//           dataIndex: 'businessEmail',
//           key: 'businessEmail',
//         },
//         {
//           title: 'Bussiness Number',
//           dataIndex: 'phoneNumber',
//           key: 'phoneNumber',
//         },
//         {
//           title: 'UTM lead ID',
//           dataIndex: 'utmleadID',
//           key: 'utmleadID',
//         },
//       ];
//   return (
//     <div>
//        <Title level={2}>UTM Mapped Leads</Title>

//        <Card extra={ <Link to="/admin/utm-mapping-form">
//         <Button variant='contained'>Map Business & UTM</Button> </Link> } style={{ width: '100%' }} >

//        <Table dataSource={dataSource} columns={columns} 
//           expandable={{
//             expandedRowRender: (record) => (
//              <>
//                <Row>
//                 <Col md={4}>
//                   <div style={{display:'grid'}}>
//                   <p style={{color:'#595959'}}>Lead Details</p>
//                   <span className="mb-2">UTM lead ID : 12</span>
//                   <span className="mb-2">Registered Date: 11-03-2025</span>
//                   <span className="mb-2 d-flex">Move on Date: 27-08-2025</span>
//                 </div>
//                 </Col>
//                 <Col md={4}>
//                   <div style={{display:'grid'}}>
//                     <span className="mb-2">Name : Mohammed Fareestha</span>
//                     <span className="mb-2">Phone Number : 873637228</span>
//                     <span className="mb-2">Email ID : www.euctoc.com</span>
//                     <span className="mb-2">Property Size : STUDIO</span>
//                   </div>
//                 </Col>
//                 <Col md={4}>
//                   <div style={{display:'grid'}}>
//                   <span className="mb-2">Moving from: Oxfordshire, UK</span>
//                   <span className="mb-2">Moving to : Newcastle upon Tyne, UK</span>
//                   <span className="mb-2">Available time to call: 12:30 PM</span>
//                   <span className="mb-2">Property Type: HOUSE</span>
//                 </div>
//                 </Col>
//                </Row>
//              </>
//             ),
//             rowExpandable: (record) => record.name !== 'Not Expandable',
//           }}/>

//        </Card>
//     </div>
//   )
// }

// export default UtmMapping



